export function toArray(nodeList) {
  return [].slice.call(nodeList);
}


// WEBPACK FOOTER //
// ./node_modules/@nrk/dh-utils/dist/module/array.js